import { useContext } from "react";
import { useQuery } from "react-query";
import { apiAxios } from "services/HttpServices";
import { LoginStateContext } from "context/Login/LoginState";

async function fetchAllClient(_, props) {
  let url;
  if (props) {
    const { keyword, clientId } = props;
    if (keyword) {
      url = `/clients?filter[name][like]=${keyword}`;
    } else if (clientId) {
      url = `/clients/${clientId}`;
    }
  } else {
    url = "/clients";
  }
  try {
    const res = await apiAxios.get(url);
    return res.data?.data;
  } catch (e) {
    console.log(e);
  }
}

function useClientData(props) {
  const { user: userState } = useContext(LoginStateContext);
  if (props) {
    return useQuery(["clients", props], fetchAllClient, {
      enabled: userState.isLoggedIn,
    });
  } else {
    return useQuery(["clients"], fetchAllClient, {
      enabled: userState.isLoggedIn,
    });
  }
}

export default useClientData;
